import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const AssignHorsesPage = () => {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const [picked, setPicked] = useState({});
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try { const { data } = await api.get(`/staff-assignments/${orgId}`); setData(data); }
    catch (e) { toast.error(e.response?.data?.message || 'Failed to load'); }
  };
  useEffect(() => { load(); }, [orgId]);

  const open = (m) => {
    setSel(m.id);
    const cur = {};
    (data.assignments || []).filter(a => a.membership_id === m.id).forEach(a => { cur[a.horse_id] = true; });
    setPicked(cur);
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/staff-assignments/${orgId}/${sel}`, { horse_ids: Object.keys(picked).filter(k => picked[k]) });
      toast.success('Assignments saved');
      setSel(null); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  if (!data) return <div className="loading-screen"><div className="spinner" /></div>;
  const member = (data.members || []).find(m => m.id === sel);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 40 }}>
      <div className="top-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: 20, padding: '4px 8px 4px 0' }}>‹</button>
          <div>
            <h1 style={{ color: 'white', fontSize: 17 }}>Assign horses</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>Who handles which horses</p>
          </div>
        </div>
      </div>
      <div style={{ padding: 12 }}>
        {!sel && (data.members || []).map(m => {
          const n = (data.assignments || []).filter(a => a.membership_id === m.id).length;
          return (
            <div key={m.id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }} onClick={() => open(m)}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{m.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{m.role} · {n} {n === 1 ? 'horse' : 'horses'} assigned</div>
              </div>
              <span style={{ color: 'var(--text-muted)' }}>›</span>
            </div>
          );
        })}
        {!sel && (data.members || []).length === 0 && (
          <div className="empty-state"><h3>No staff yet</h3><p>Invite staff from Members and invites first</p></div>
        )}
        {sel && (
          <>
            <div className="section-label">Horses for {member?.name}</div>
            <div className="card" style={{ padding: '4px 14px' }}>
              {(data.horses || []).map(h => (
                <label key={h.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--border-color)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!picked[h.id]} onChange={e => setPicked(p => ({ ...p, [h.id]: e.target.checked }))} style={{ accentColor: 'var(--cr-primary)' }} />
                  <span style={{ fontSize: 14, fontWeight: 500 }}>{h.name}</span>
                </label>
              ))}
              {(data.horses || []).length === 0 && <div style={{ fontSize: 13, color: 'var(--text-muted)', padding: '10px 0' }}>No horses found in this barn yet</div>}
            </div>
            <button className="btn btn-primary btn-full" onClick={save} disabled={saving} style={{ marginTop: 10 }}>{saving ? 'Saving…' : 'Save assignments'}</button>
            <button className="btn btn-secondary btn-full" onClick={() => setSel(null)} style={{ marginTop: 8 }}>Back to staff list</button>
          </>
        )}
      </div>
    </div>
  );
};

export default AssignHorsesPage;
